import ArticleDetail from '../components/ArticleDetail';

function Article({ articles }) {
  return <ArticleDetail articles={articles} />;
}

export default Article;